import {
  ACTION_ARGS,
  CONTAINER_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { fn, hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from '../../../core/menu/item.gjs';
import Super from '../../../core/menu/parent.gjs';

const METADATA = Metadata.define({
  description: 'Menu component for filter buttons',
  extends: [
    pick(ACTION_ARGS, [
      { name: 'onSelect', description: 'Action triggered when a menu item is selected' },
    ]),
    pick(CONTAINER_ARGS, ['fitContent']),
    pick(MENU_ARGS, ['menuAnchorElement', 'menuAnchorOffset', 'menuOpen']),
  ],
  name: 'Filter Menu',
});

export default class SpdsActionButtonFilterMenu extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-button-filter-menu';

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @anchorOffset={{@anchorOffset}}
      @fitContent={{@fitContent}}
      @id={{this.id}}
      @open={{@open}}
      class={{this.classes}}
      data-test-spds-action-button-filter-menu
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          item=(component
            MenuItem
            onClick=@onSelect
            registerComponent=(fn this.registerItem false)
            unregisterComponent=this.unregisterItem
          )
        )
      }}
    </Menu>
  </template>
}

export const ACTION_BUTTON_FILTER_MENU_METADATA = SpdsActionButtonFilterMenu.metadata;
